import ModeService from '../services/ModeService';

export default {
    methods: {
        /**
         * In pos mode?
         *
         * @return {Boolean}
         */
        inPosMode() {
            return ModeService.inPosMode();
        },

        /**
         * Get token of pos.
         *
         * @return {String|null}
         */
        getPosToken() {
            return ModeService.getPosToken();
        },

        /**
         * Set token of pos.
         *
         * @param {String} token
         */
        setPosToken(token) {
            ModeService.setPosToken(token);
            this.$emit('posModeChanged', this.inPosMode);
        },

        /**
         * Set POS.
         *
         * @param {Object} pos
         */
        setPos(pos) {
            ModeService.setPos(pos);
        },

        /**
         * Get POS.
         *
         * @return {Object}
         */
        getPos() {
            return ModeService.getPos();
        },

        /**
         * Clear code of event.
         */
        clearEventCode() {
            ModeService.clearEventCode();
        },

        /**
         * Is this a POS of type kiosk?
         *
         * @return {boolean}
         */
        isKiosk() {
            return ModeService.isKiosk();
        },

        /**
         * Is this a POS of type cashier?
         *
         * @return {boolean}
         */
        isCashier() {
            return ModeService.isCashier();
        }
    }
}
